import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCheckmark1Small: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"checkmark-1-small"} maskId="square-filled-radius-0-stroke-1-IconCheckmark1Small"><path fillRule="evenodd" clipRule="evenodd" d="M17.189 7.34103L10.9658 17.298L6.79285 13.125L7.49995 12.4179L10.7841 15.702L16.341 6.81104L17.189 7.34103Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCheckmark1Small;
